var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.19L16.81 3a1.5 1.5 0 00-2.12 0l-2.47 2.47-8.78 8.78A1.49 1.49 0 003 15.31v4.19A1.502 1.502 0 004.5 21h4.19a1.491 1.491 0 001.06-.44L21 9.31a1.502 1.502 0 000-2.12zm-3 3L13.81 6l1.94-1.94 4.19 4.19L18 10.19z",
    fill: "#00263A"
  })));
}
export default SvgPencilMedium;